import { api } from "./urlApi";

export const getTipos_ceremonias = async () => {
  const url = `${api}/tipos_ceremonias/get.php`;

  const resp = await fetch(url);
  const tipos_ceremonias = await resp.json();

  return tipos_ceremonias;
};

export const getCeremonias = async (start_date = "", end_date = "") => {
  let url = `${api}/ceremonias/get.php`;

  if (start_date && end_date) {
    url += `?start_date=${start_date}&end_date=${end_date}`;
  } else if (start_date) {
    url += `?start_date=${start_date}`;
  } else if (end_date) {
    url += `?end_date=${end_date}`;
  }

  const resp = await fetch(url);
  const ceremonias = await resp.json();

  return ceremonias;
};

export const getCeremoniasWithAcolitos = async (
  idCeremonia = null,
  start_date = "",
  end_date = ""
) => {
  let url = `${api}/ceremonias/getWithAcolitos.php`;

  if (start_date && end_date) {
    url += `?start_date=${start_date}&end_date=${end_date}`;
  } else if (start_date) {
    url += `?start_date=${start_date}`;
  } else if (end_date) {
    url += `?end_date=${end_date}`;
  }

  if (idCeremonia) {
    url += `?id="${idCeremonia}"`;
  }

  const resp = await fetch(url);
  const ceremonias = await resp.json();

  return ceremonias;
};

export const getAsistencias = async (start_date = "", end_date = "") => {
  let url = `${api}/ceremonias/getAsistencias.php`;

  if (start_date && end_date) {
    url += `?start_date=${start_date}&end_date=${end_date}`;
  } else if (start_date) {
    url += `?start_date=${start_date}`;
  } else if (end_date) {
    url += `?end_date=${end_date}`;
  }

  const resp = await fetch(url);
  const asistencias = await resp.json();

  return asistencias;
};

// POST

export const postCeremonia = async (ceremonia) => {
  const url = `${api}/rol/post.php`;

  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ceremonia),
    });

    const data = await resp.json();
    return data;
  } catch (error) {
    return false;
  }
};

// PUT

export const putCeremonia = async (ceremonia) => {
  const url = `${api}/rol/put.php`;

  try {
    const resp = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ceremonia),
    });

    const data = await resp.json();

    return data;
  } catch (error) {
    return false;
  }
};

export const putAsistencia = async (rol) => {
  const url = `${api}/rol/putAsistencia.php`;

  try {
    const resp = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rol),
    });

    return resp;
  } catch (error) {
    return false;
  }
};

// DELETE

export const deleteCeremonia = async (ceremonia) => {
  const url = `${api}/ceremonias/delete.php`;

  try {
    const resp = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ceremonia),
    });

    const data = await resp.json();

    return data;
  } catch (error) {
    return error;
  }
};
